module.exports = __webpack_public_path__ + "img/zyz.da79414b.png";